export default "__VITE_ASSET__Ck7k6A1k__"